export const POS_PRINTERS = [
    { value: 1, label: '1 - Receipt'},
    { value: 2, label: '2 - Bar' },
    { value: 3, label: '3 - Kitchen1' },
    { value: 4, label: '4 - Kitchen2' },
    { value: 5, label: '5 - Others' },
    { value: 6, label: '6 - Others' },
    { value: 7, label: '7 - Others' },
    { value: 8, label: '8 - Others' }
]
